module.exports = __webpack_public_path__ + "static/media/document.abba5181.jpg";